import { CardContent, CardHeader, Stack } from "@mui/material";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import { FilterAlt } from "@mui/icons-material";
import Table from "../../../components/Table";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { fetchData } from "../../../services";
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";
import TransformDictionaryFilterDialog from "./components/TransformDictionaryFilterDialog";

const TransformFunctionDictionaryList = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [filterData, setFilterData] = useState({
    isActive: "",
  });

  const currentPage = useSelector(
    (state) => state?.transformDictionaryStore?.currentPage
  );
  const rowsPerPage = useSelector(
    (state) => state?.transformDictionaryStore?.rowsPerPage
  );
  const totalPages = useSelector(
    (state) => state?.transformDictionaryStore?.totalPages
  );

  const [TransformDictionaryData, setTransformDictionaryData] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchBodyStyleList();
  }, [currentPage, rowsPerPage, search]);

  //List API
  const fetchBodyStyleList = async () => {
    setCircleLoading(true);
    try {
      let url = `/api-engine/transform-dictionary/?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`;

      //for active and inactive status
      if (filterData.isActive !== "") {
        url += `&isActive=${filterData.isActive}`;
      }

      const response = await fetchData(url);

      if (response?.success) {
        setTransformDictionaryData(response?.data?.items);
        dispatch(setTotalPages(response?.data?.totalPages));
      } else {
        //throw error
        showSnackbar("Error Fetching Body Style List", "error");
      }
    } catch (error) {
      console.error("Error Fetching Body Styles:", error);
      showSnackbar(error?.response?.data?.message || "Error Fetching Transform Function Dictionary List", "error");
    } finally {
      setCircleLoading(false);
    }
  };

  //table mapping
  const TransformDictionaryTable = {
    columns: [
      {
        key: "sno",
        label: "S.No.",
        renderCell: (row) => row.sno,
      },
      {
        key: "code",
        label: "Code",
        renderCell: (row) => row.code,
      },
      {
        key: "description",
        label: "Description",
        renderCell: (row) => row.name,
      },
      {
        key: "sampleInput",
        label: "Sample Input",
        renderCell: (row) => row.gInsurerId,
      },
      {
        key: "sampleOutput",
        label: "Sample Output",
        renderCell: (row) => row.gInsurerId,
      },
      {
        key: "configSchema",
        label: "Config Schema",
        renderCell: (row) => row.gInsurerId,
      },
      {
        key: "isActive",
        label: "Status",
        renderCell: (row) => (
          <span>
            {row.isActive ? (
              <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
            ) : (
              <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
            )}
          </span>
        ),
      },
    ],
    rows: TransformDictionaryData?.map((item, index) => ({
      id: item?.id,
      sno: index + 1,
      code: item?.code || "",
      name: item?.name || "",
      category: item?.category || "",
      sampleInput: item?.sampleInput || "",
      sampleOutput: item?.sampleOutput || "",
      configSchema: item?.configSchema || "",
      isActive: item?.isActive,
    })),
  };

  const actions = {
    view: true,

    onView: (row) => {
      navigate(
        `/api-integration-engine/transform-function-dictionary/transform-dictionary-details?pageType=view&id=${row.id}`
      );
    },
  };

  const handlePaginationChange = (page) => {
    dispatch(setCurrentPage(page));
  };

  const handleRowsPerPageChange = (rowsPerPage) => {
    dispatch(setRowsPerPage(rowsPerPage));
    dispatch(setCurrentPage(1));
  };

  const handleSearch = (value) => {
    setSearch(value);
  };

  return (
    <DashboardLayout>
      <CardHeader
        title={
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Stack direction="column" spacing={0}>
              <MaterialTypography variant="h5" fontWeight="medium">
                Transform Function Dictionary List
              </MaterialTypography>
              <MaterialTypography variant="caption" color="text">
                List of Transform Function Dictionary.
              </MaterialTypography>
            </Stack>
            <Stack direction="row" spacing={1}>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<FilterAlt />}
                onClick={(event) => setAnchorEl(event.currentTarget)}
              >
                Filter
              </MaterialButton>
            </Stack>
          </Stack>
        }
      />
      <CardContent>
        <Table
          columns={TransformDictionaryTable?.columns}
          data={TransformDictionaryTable?.rows}
          actions={actions}
          pagination={{
            totalPages,
            currentPage,
            onPageChange: (page) => handlePaginationChange(page),
            rowsPerPage,
            onRowsPerPageChange: (rowsPerPage) =>
              handleRowsPerPageChange(rowsPerPage),
            rowsPerPageOptions: [5, 10, 15, 20],
          }}
          getRowKey={(row) => row.id}
          className="custom-table"
          noDataLabel="No Transform Function Dictionary found"
          handleSearch={handleSearch}
        />
      </CardContent>
      <TransformDictionaryFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
          setAnchorEl(null); // close popup
          fetchBodyStyleList(); // call API after filter applied
        }}
      />
    </DashboardLayout>
  );
};

export default TransformFunctionDictionaryList;
